import { createReducer } from '@reduxjs/toolkit';
import {
  addCreatedActionItem,
  createMentorshipProgramActionItem,
  deleteMentorshipProgramActionItem,
  getMentorshipProgramActionItems,
  removeDeletedActionItem,
  setMentorshipProgramActionItemsTotalCount,
  updateMentorshipProgramActionItem,
  updateModifiedActionItem,
} from 'redux/actions/mentoring-program-action-items';
import { normalize } from 'normalizr';
import { MentorshipProgramActionItemsSchema } from 'redux/schemas/api/mentoring-program-action-items';
import { initialRootState } from '.';

const setProgramActionItemActionHandler = (state, action) => {
  const { meta: { arg: { connectionId } } } = action;
  const { entities: { mentorshipProgramActionItems } } = normalize(
    action.payload,
    MentorshipProgramActionItemsSchema,
  );
  state.models.mentorshipProgramActionItems[connectionId] = {
    ...state.models.mentorshipProgramActionItems[connectionId],
    items: {
      ...state.models.mentorshipProgramActionItems[connectionId]?.items,
      ...mentorshipProgramActionItems,
    },
  };
};

const addCreatedActionItemHandler = (state, action) => {
  const { connectionId, actionItem } = action.payload;
  if (!state.models.mentorshipProgramActionItems[connectionId]?.items) {
    state.models.mentorshipProgramActionItems[connectionId] = {
      ...state.models.mentorshipProgramActionItems[connectionId],
      items: {},
    };
  }
  state.models.mentorshipProgramActionItems[connectionId].items[actionItem.id] = actionItem;
};

const updateModifiedActionItemHandler = (state, action) => {
  const { connectionId, actionItem } = action.payload;
  if (!state.models.mentorshipProgramActionItems[connectionId]?.items) {
    state.models.mentorshipProgramActionItems[connectionId] = {
      ...state.models.mentorshipProgramActionItems[connectionId],
      items: {},
    };
  }
  state.models.mentorshipProgramActionItems[connectionId].items[actionItem.id] = actionItem;
};

const removeDeletedActionItemHandler = (state, action) => {
  const { connectionId, actionItemId } = action.meta?.arg || action.payload;
  if (state.models.mentorshipProgramActionItems[connectionId]?.items) {
    delete state.models.mentorshipProgramActionItems[connectionId].items[actionItemId];
  }
};

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(
      getMentorshipProgramActionItems.fulfilled,
      setProgramActionItemActionHandler,
    )
    .addCase(
      setMentorshipProgramActionItemsTotalCount,
      (state, action) => {
        const { connectionId, totalCount } = action.payload;
        state.models.mentorshipProgramActionItems[connectionId] = {
          items: {},
          ...state.models.mentorshipProgramActionItems[connectionId],
          totalCount,
        };
      },
    )
    .addCase(createMentorshipProgramActionItem.fulfilled, addCreatedActionItemHandler)
    .addCase(updateMentorshipProgramActionItem.fulfilled, updateModifiedActionItemHandler)
    .addCase(deleteMentorshipProgramActionItem.fulfilled, removeDeletedActionItemHandler)
    .addCase(addCreatedActionItem, addCreatedActionItemHandler)
    .addCase(updateModifiedActionItem, updateModifiedActionItemHandler)
    .addCase(removeDeletedActionItem, removeDeletedActionItemHandler);
});
